import { productImageStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { css } from "styled-components";

productImageStyles.compareCheckbox = {
    css: css`
        align-self: center;
        padding-top: 20px;
    `,
    typographyProps: {
        css: css`
            white-space: nowrap;
        `,
    },
};

productImageStyles.productImage = {
    image: {
        css: css`
        img {
            min-width: 100%;
        }
            `,
    },
    linkWrappingImage: {
        css: css`
        width: 100%;
        justify-content: center;`,
    },
};

productImageStyles.wrapper = {
    css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            padding: 10px 0;
        `,
}